import React from "react";
// import commonBanner
import CommonBanner from "../component/Common/CommonBanner";
// import ContactArea
import ContactArea from "../component/Contact";
import { Helmet } from "react-helmet-async";
import { ImageConstants } from "../assets/img/ImageConstants";
import StaticSEOTags from "../component/DynamicSEO/StaticSEOTags";
const Contact = ( ) => {
  return (
    <>
      <StaticSEOTags
        fallbackTitle="Pakistan's Leading Travel Agency | Polifly Travels"
        fallbackDescription="Discover unforgettable journeys with Polifly Travels. The leading travel agency in Karachi, Pakistan, dedicated to making every trip extraordinary."
        fallbackKeywords="Polifly Travels"
        fallbackOgTitle="Pakistan's Leading Travel Agency | Polifly Travels"
        fallbackOgDescription="Discover unforgettable journeys with Polifly Travels. The leading travel agency in Karachi, Pakistan, dedicated to making every trip extraordinary."
        fallbackCanonicalUrl="https://poliflytravels.com/"
      />
      {/* <DynamicSEOTags
        fallbackTitle="Your Page Title"
        fallbackDescription="Your page description"
        fallbackKeywords="your, keywords, here"
        fallbackOgTitle="Your OG Title"
        fallbackOgDescription="Your OG Description"
        fallbackCanonicalUrl="https://yoursite.com/your-page"
      /> */}

      {/* <CommonBanner heading="Contact" pagination="Contact" />
       */}
      <CommonBanner
        heading="Contact"
        img={ImageConstants.contact}
        pagination="Contact"
      />
      <ContactArea />
    </>
  );
};

export default Contact;
